import i18n from "../../util/i18n.ts";
import { translateInjuryName } from "../../util/injuryNames.ts";

const Injuries = ({
  injuries,
  showRatings,
}: {
  injuries: {
    games: number;
    season: number;
    type: string;
    ovrDrop?: number;
    potDrop?: number;
  }[];
  showRatings: boolean;
}) => {
  if (injuries === undefined || injuries.length === 0) {
    return <p>{i18n.t("common.none", { ns: "ui", defaultValue: "None" })}</p>;
  }

  const totals: {
    games: number;
    ovrDrop: number | undefined;
    potDrop: number | undefined;
  } = {
    games: 0,
    ovrDrop: undefined,
    potDrop: undefined,
  };
  for (const injury of injuries) {
    totals.games += injury.games;
    if (injury.ovrDrop !== undefined) {
      if (totals.ovrDrop === undefined) {
        totals.ovrDrop = 0;
      }
      totals.ovrDrop += injury.ovrDrop;
    }
    if (injury.potDrop !== undefined) {
      if (totals.potDrop === undefined) {
        totals.potDrop = 0;
      }
      totals.potDrop += injury.potDrop;
    }
  }

  return (
    <table className="table table-sm table-borderless mb-3">
      <thead>
        <tr>
          <th>{i18n.t("title.Year", { ns: "cols", defaultValue: "Year" })}</th>
          <th>{i18n.t("title.Type", { ns: "cols", defaultValue: "Type" })}</th>
          <th className="text-end">
            {i18n.t("title.Games", { ns: "cols", defaultValue: "Games" })}
          </th>
          {showRatings ? (
            <>
              <th className="text-end">
                {i18n.t("title.Ovr Drop", {
                  ns: "cols",
                  defaultValue: "Ovr Drop",
                })}
              </th>
              <th className="text-end">
                {i18n.t("title.Pot Drop", {
                  ns: "cols",
                  defaultValue: "Pot Drop",
                })}
              </th>
            </>
          ) : null}
        </tr>
      </thead>
      <tbody>
        {injuries.map((injury, i) => (
          <tr key={i}>
            <td>{injury.season}</td>
            <td>{translateInjuryName(injury.type)}</td>
            <td className="text-end">{injury.games}</td>
            {showRatings ? (
              <>
                <td className="text-end">{injury.ovrDrop}</td>
                <td className="text-end">{injury.potDrop}</td>
              </>
            ) : null}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <th colSpan={2}>{i18n.t("common.total", { ns: "ui", defaultValue: "Total" })}</th>
          <th className="text-end">{totals.games}</th>
          {showRatings ? (
            <>
              <th className="text-end">{totals.ovrDrop}</th>
              <th className="text-end">{totals.potDrop}</th>
            </>
          ) : null}
        </tr>
      </tfoot>
    </table>
  );
};

export default Injuries;
